import { FC } from 'react';
import * as S from './styled';

const Separator: FC = () => {
  return (
    <S.FormWrapperMainSeparator>
      <span>or</span>
    </S.FormWrapperMainSeparator>
  );
};

export default Separator;
